import App from '@/App.vue'

import { defaultColors, tailwindColorToCssVar } from '@/config/color.config'

import { routeConfig } from '@/config/route.config'
import { getThemeSettings } from '@/lib'
import { VueQueryPlugin } from '@tanstack/vue-query'
import VueDnDKitPlugin from '@vue-dnd-kit/core'
import { createHead } from '@vueuse/head'
import { createPinia } from 'pinia'
import { getColors } from 'theme-colors'
import { createApp } from 'vue'
import { createRouter, createWebHistory } from 'vue-router'
import './style.css'

const router = createRouter({
  history: createWebHistory(),
  routes: routeConfig,
  scrollBehavior() {
    const mainContainer = document.querySelector('#main-container')
    return {
      el: mainContainer,
      top: 0,
    }
  },
})

const { appTitle, colors, isDark, flat = false, disableAnimation } = getThemeSettings()
const hasDarkModeColors = colors.filter((color) => color.Mode === 'Dark').length > 0
const shouldUseDarkTheme =
  (hasDarkModeColors && isDark) ||
  (hasDarkModeColors && window.matchMedia('(prefers-color-scheme: dark)').matches)

let tailwindColors: Record<string, string> = defaultColors

const contextColors = colors.filter((color) =>
  shouldUseDarkTheme ? color.Mode === 'Dark' : color.Mode === 'Light',
)

contextColors.forEach((color) => {
  tailwindColors = {
    ...tailwindColors,
    ...tailwindColorToCssVar(color.Name, getColors(color.Color)),
  }
})

const root = document.documentElement

Object.entries(tailwindColors).forEach(([key, value]) => {
  root.style.setProperty(key, value)
})

if (flat) root.classList.add('flat')

if (disableAnimation) root.classList.add('animation-disabled')

const app = createApp(App, {
  isDark: shouldUseDarkTheme,
})
const pinia = createPinia()

const head = createHead({
  titleTemplate: (title) =>
    title ? `${title} ${appTitle.trim() ? `| ${appTitle}` : ''}` : appTitle,
})

app.use(router)
app.use(pinia)
app.use(VueQueryPlugin)
app.use(VueDnDKitPlugin)
app.use(head)
app.mount('#app-root')
